import { ChevronRight, ExternalLink } from 'lucide-react';

export default function ToolCard({ tool, setCurrentPage }) {
  return (
    <div
      className={`bg-white rounded-xl p-6 shadow-sm border border-gray-100 ${tool.available ? 'hover:shadow-md transition-shadow cursor-pointer' : 'opacity-60'}`}
      onClick={() => {
        if (!tool.available) return;
        if (tool.externalUrl) {
          window.open(tool.externalUrl, '_blank', 'noopener,noreferrer');
        } else if (tool.page) {
          setCurrentPage(tool.page);
        }
      }}
    >
      <div className="flex items-start justify-between mb-3">
        <span className="bg-green-100 text-green-900 text-xs font-medium px-2.5 py-1 rounded-full">
          {tool.category}
        </span>
        {!tool.available && (
          <span className="bg-gray-100 text-gray-500 text-xs px-2.5 py-1 rounded-full">準備中</span>
        )}
      </div>
      <h3 className="font-bold text-gray-800 mb-2">{tool.title}</h3>
      <p className="text-gray-500 text-sm leading-relaxed">{tool.description}</p>
      {tool.available && (
        <div className="mt-4 flex items-center text-green-800 text-sm font-medium gap-1">
          使ってみる {tool.externalUrl ? <ExternalLink size={14} /> : <ChevronRight size={14} />}
        </div>
      )}
    </div>
  );
}
